/* eslint-disable camelcase */
import React, { useState } from 'react';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import SubmittedCheck from 'src/assets/images/SubmittedCheck.svg';
import Account from './Account';
import ReceivedSets from './ReceivedSets';
import { useSelector, useDispatch } from 'react-redux';
import ReceiveSetsFooter from '../ReceiveSetsFooter';
import { getDropdownValues } from '../../redux/actions/index';
import { useTranslation } from 'react-i18next';
import PageLevelMessage from 'src/common/refactoredComponents/pageLevelMessage'; 
import { DARK_GRAY_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OnSubmit = ({
    setIsSubmitClicked,
    counterMessage,
    setCounterMessage,
}) => {
    const [expandedCard, setExpandedCard] = useState({
        account_card: true,
        sets_card: true,
    });
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { accountId, territoryId, territories, myCaseRef, setsList } =
        useSelector((state) => ({
            territoryId: state.receiveSetsReducer.surgeryDetails.territoryId,
            accountId: state.receiveSetsReducer.surgeryDetails.accountId,
            receiveSetsLoading:
                state.createReceiveSetsReducer.receiveSetsLoading,
            territories:
                state.receiveSetsDetailsDropdownsReducer.territories.items,
            myCaseRef:
                state.createReceiveSetsReducer.createReceiveSets.myCaseRef,
            setsList: state.receiveSetsListDataReducer.receiveSetsListData,
        }));
    useEffectWithErrorLogging(() => {
        dispatch(getDropdownValues({ dropDownName: 'territories' }));
    }, []);
    let selectedTerritory = territories.find(
        (territories) => territories.terrirotryCode === territoryId
    );

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    return (
        <>
            <PageLevelMessage
                status="success"
                message={t('receiveSets.ReceiveSubmit.OnSubmit.requestMsg')}
                surgeryNumber={myCaseRef}
                messageTextAlign="left"
                messagewhiteSpace="nowrap"
                mycaseNoColor={DARK_GRAY_FONT_COLOR}
                imgSrc={SubmittedCheck}
                isFromReceiveSet={true}
            />
            <CollapsableCard id="receiveSets-onSubmit-receiveSubmit-accountDetails"
                title={t('consignmentBilling.replen.replenListView.replenListViewMobile.details')}
                onClick={() =>
                    toggleCard('account_card', !expandedCard.account_card)
                }
                isExpanded={expandedCard.account_card}
                currentActivity
                fontSizeMobile={'16px'}
            >
                {expandedCard.account_card ? (
                    <Account
                        selectedTerritory={selectedTerritory}
                        accountId={accountId}
                    />
                ) : null}
            </CollapsableCard>
            <CollapsableCard id="receiveSets-onSubmit-receiveSubmit-receivedSets"
                title={t('receiveSets.ReceiveSubmit.OnSubmit.receivedSets') + `(${setsList && setsList.length})`}
                onClick={() => toggleCard('sets_card', !expandedCard.sets_card)}
                isExpanded={expandedCard.sets_card}
                currentActivity
                fontSizeMobile={'16px'}
            >
                {expandedCard.sets_card ? (
                    <ReceivedSets setsList={setsList} />
                ) : null}
            </CollapsableCard>
            <ReceiveSetsFooter
                submitSuccess={true}
                setIsSubmitClicked={setIsSubmitClicked}
                counterMessage={counterMessage}
                setCounterMessage={setCounterMessage}
            />
        </>
    );
};

export default OnSubmit;
